import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SendIcon = (props) => (
  <Svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M24.21 25.227 3.14 15.15a1.25 1.25 0 0 1 0-2.256L24.21 2.817a1.25 1.25 0 0 1 1.746 1.456l-2.108 7.728a.5.5 0 0 1-.415.364l-10.21 1.387a.25.25 0 0 0-.195.15l-.018.062a.25.25 0 0 0 .157.268l.055.015 10.2 1.387a.5.5 0 0 1 .414.364l2.12 7.772a1.25 1.25 0 0 1-1.746 1.457Z"
      fill={props.color}
    />
  </Svg>
);
SendIcon.defaultProps = {
  color: "#f7f7f7",
};
export default SendIcon;
